module.exports = __webpack_public_path__ + "static/media/CHAWP_MENU-normal.590e3f4f.png";